import { render, staticRenderFns } from "./BoostingProductivity.vue?vue&type=template&id=c47420b2&"
import script from "./BoostingProductivity.vue?vue&type=script&lang=js&"
export * from "./BoostingProductivity.vue?vue&type=script&lang=js&"
import style0 from "./BoostingProductivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports